module.exports = require('./dist/amenity/amenity.js');
